import React from 'react';
import { FiLoader } from 'react-icons/fi';

const Button = React.forwardRef(({ className, variant, size, loading = false, children, ...props }, ref) => {
    const baseClasses = "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background";

    const variants = {
        solid: "bg-charcoal-900 text-white hover:bg-charcoal-800 dark:bg-white dark:text-charcoal-900 dark:hover:bg-charcoal-200",
        outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground dark:border-charcoal-700 dark:text-charcoal-100",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        destructive: "bg-red-600 text-white hover:bg-red-700 shadow-sm",
        "destructive-outline": "border border-red-200 bg-white text-red-600 hover:bg-red-50",
    };

    const sizes = {
        sm: "h-9 px-3 rounded-md",
        md: "h-10 py-2 px-4",
        lg: "h-11 px-8 rounded-md",
    };

    const variantClass = variants[variant] || variants.solid;
    const sizeClass = sizes[size] || sizes.md;

    return (
        <button
            className={`${baseClasses} ${variantClass} ${sizeClass} ${className}`}
            ref={ref}
            disabled={loading || props.disabled}
            aria-busy={loading}
            {...props}
        >
            {loading && <FiLoader className="mr-2 h-4 w-4 animate-spin" />}
            {children}
        </button>
    );
});

Button.displayName = "Button";

export { Button };
